import { createAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import { RootState } from '.';

const HydrateAction = createAction<RootState>(HYDRATE);

export default HydrateAction;
